import script from "./dropdownIncoterm.vue?vue&type=script&setup=true&lang=js"
export * from "./dropdownIncoterm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__